//import { taskColumns } from "@/columns";
import ColumnsDrawerTasksApprove from "@/columns/ColumnsDrawers";
import Vue from "vue";
const vue = new Vue();

export const getTableData = async function (dthis) {
  //console.log("getTableData");
  let tableData = [];
  await vue.$http
    .get("/api/MessageApi/GetAllPending", {
      timeout: 3 * 60 * 1000,
      params: {
        EmployeeId: dthis.currentUser.EmployeeId,
        OptionObjective: 1
      }
    })
    .then((resp) => {
      //console.log("tableData: ", resp);
      tableData = resp.data;
    });
  return tableData;
};

export const TaskColumns = ColumnsDrawerTasksApprove;
export const Actions = [
  {
    icon: "el-icon-view",
    label: "Ver",
    command: "view-task-view-others",
    condition: (row) => row.Types != "task"
  },
  {
    icon: "el-icon-view",
    label: "Ver",
    command: "view-task-view",
    condition: (row) => row.Types == "task"
  },
  {
    icon: "el-icon-edit",
    label: "Editar",
    command: "view-task-edit",
    condition: (row) => row.Types == "task" && !row.PercentageProsposal
  },
  {
    icon: "el-icon-document",
    label: "Ver Evidencia",
    command: "view-task-evidence"
  },
  {
    icon: "el-icon-check",
    label: "Aprobar",
    command: "approve-task-percent",
    condition: (row) => row.PercentageProsposal
  },
  {
    icon: "el-icon-ccw",
    label: "Re-Abrir",
    command: "reopen-task",
    condition: (row) => row.PercentageProsposal
  },
  {
    icon: "el-icon-circle-close",
    label: "Cancelar",
    command: "Cancel-task",
    condition: (row) => row.Types == "InternalRequest"
  }
];
export const ActionHandler = async function (action) {
  let rowObjective;
  if (action.row.ObjetiveID) {
    await vue.$http
      .get("/api/CMI/Objetives/getGanttObjetiveByID", {
        params: {
          ID: action.row.ObjetiveID
        }
      })
      .then((response) => {
        rowObjective = response.data;
      });
  }

  // this.taskDrawer = true;
  let rowData = {
    task: action.row,
    objective: rowObjective
  };
  switch (action.command) {
    case "view-task-view-others":
      this.$message({
        type: "warning",
        message:
          "Esta acción todavía no está habilitada. Disculpe los inconvenientes."
      });
      break;
    case "view-task-view":
      action.refs.taskFormDrawer.show(rowData, true, false, false, false);
      break;

    case "view-task-evidence":
      //console.log("rowData: ", rowData)
      action.refs.taskFormDrawer.openFile(rowData.task.DocumentURL);
      break;

    case "view-task-edit":
      action.refs.taskFormDrawer.show(rowData, false, false, true);
      break;

    case "approve-task-percent":
      await AcceptedValue(rowData.task);
      break;

    case "reopen-task":
      await ReopenTask(rowData.task);
      break;

    case "Cancel-task":
      this.RowData = action;
      this.StatusToChange = 4;
      //this.CancelRequest(action, 4);
      this.centerDialogVisible = true;
      break;
  }
  return action;
};

async function AcceptedValue(row) {
  // SaveAfterAceptWhoCanChange(row);
  //let isSuccessful = false;
  let TaskID = row.ID;
  let updated = false;
  await vue
    .$prompt(
      "Por favor escribir un comentario de confirmación",
      "Mensaje de confirmación"
    )
    .then((result) => {
      switch (result.action) {
        case "confirm":
          if (result.value) {
            vue.$http
              .post(`/api/cmi/task/ApproveTaskDrawer?ID=${TaskID}`)
              .then(() => {
                vue.$message({
                  message: "Tarea Aprobada Exitosamente",
                  type: "success"
                });
                updated = true;
                vue.$emit("update-table");
              })
              .catch((err) => {
                vue.$message({ type: "danger", message: err });
              });
          } else {
            vue.$message({
              message: "Favor introduzca un comentario válido",
              type: "error"
            });
          }
          break;

        default:
          break;
      }
    });
  if (updated) {
    return row;
  }
}

async function ReopenTask(row) {
  let TaskID = row.ID;
  let updated = false;
  await vue
    .$prompt(
      "Por favor escribir un comentario de confirmación",
      "Mensaje de confirmación"
    )
    .then((result) => {
      switch (result.action) {
        case "confirm":
          if (result.value) {
            vue.$http
              .post(
                `/api/MessageApi/UpdateStateTaskGant?ID=${TaskID}&Comentarios=${result.value}`
              )
              .then(() => {
                vue.$message({
                  message: "Tarea Reabierta Exitosamente",
                  type: "success"
                });
                updated = true;
                vue.$emit("update-table");
              })
              .catch((err) => {
                vue.$message({ type: "danger", message: err });
              });
          } else {
            vue.$message({
              message: "Favor introduzca un comentario válido",
              type: "error"
            });
          }
          break;

        default:
          break;
      }
    });
  if (updated) {
    return row;
  }
}
